import { Observable } from 'rxjs/Observable';
import { IServerResponse, IConnectionStatus, getFirstChildNode, IXmlNode } from '@/app-modules/server-communications';
import { IAuthenticationResponse } from '@/app-modules/server-service';

class AuthenticationFailedResponse implements IAuthenticationResponse {
    public success: boolean;
    public reason: string;

    constructor(authNode: IXmlNode) {
        this.success = false;
        this.reason = authNode.attributes.reason;
        console.log('failed to connect to game');
    }
}

class AuthenticationSuccessResponse implements IAuthenticationResponse {
    public success: boolean;
    public username: string;
    public balance: number;
    public club: number;
    public ticketPrice: number;
    // tech debt - we are passing the bingo 75 pattern in the auth message; Either change that or create a new factory ? -> FM
    public currentpattern: string;
    public currentPatternName: string;
    // tech debt - we are passing the callHistory from tombola roulette in the auth message; Either change that or create a new factory ? -> FM
    public callHistory: string;

    constructor(authNode: IXmlNode) {
        this.success = true;
        this.username = authNode.attributes.user;
        this.balance = Number(authNode.attributes.balance);
        this.club = Number(authNode.attributes.club);
        this.ticketPrice = Number(authNode.attributes.ticketprice);
        this.currentpattern = authNode.attributes.pattern;
        this.currentPatternName = authNode.attributes.patternname;
        this.callHistory = authNode.attributes.callhistory;
    }
}

class AuthenticationResponse {
    public static filter(response: IServerResponse): boolean {
        return /command="auth"/g.test(response.Contents) ||
               /<auth /g.test(response.Contents);
    }

    public static map(response: IServerResponse): IAuthenticationResponse {
        const node = getFirstChildNode(response.Contents);

        if (node === null) {
            throw new Error('Failed to map response');
        }

        return (node.name === 'auth')
            ? new AuthenticationFailedResponse(node)
            : new AuthenticationSuccessResponse(node);
    }

    public static asStream(response$: Observable<IServerResponse>, error$: Observable<Error>, connectionStatus$: Observable<IConnectionStatus>): Observable<IAuthenticationResponse> {
        return response$.switchMap((data) => Observable.of(data)
        .filter(AuthenticationResponse.filter)
        .map(AuthenticationResponse.map)
        .catch((error) => {
          // error$.next(error)
          return Observable.empty<IAuthenticationResponse>();
        })).share();
    }
}

// TECH DEBT: Should this live here?
interface ICincoAuthenticationResponse extends IAuthenticationResponse {
    ticketPrice: number;
}

interface IBingo75AuthenticationResponse extends IAuthenticationResponse {
    currentpattern: string;
    currentPatternName: string;
}

interface ITombolaRouletteAuthenticationResponse extends IAuthenticationResponse {
    callHistory: string;
}

export { ICincoAuthenticationResponse, IBingo75AuthenticationResponse, ITombolaRouletteAuthenticationResponse, AuthenticationSuccessResponse, AuthenticationResponse};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/components/game/_domain/server/auth/auth-response.ts